import { ContactPersonsResponse } from './contactPerson'
import { Action } from './type'

export type ContactPersonsFilterListAction = Action & {
  type: 'SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST'
}

export const FETCH_CONTACT_PERSONS_FILTER_LIST =
  'FETCH_CONTACT_PERSONS_FILTER_LIST'
export function fetchContactPersonsFilterList() {
  return { type: FETCH_CONTACT_PERSONS_FILTER_LIST }
}

export const SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST =
  'SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST'
export function successFetchContactPersonsFilterList(
  contactPersons: ContactPersonsResponse
) {
  return {
    type: SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST,
    payload: contactPersons,
  }
}

export const FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST =
  'FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST'
export function failedFetchContactPersonsFilterList(message: string) {
  console.log('Error:  FAILURE_FETCH_CONTACT_PERSONS_FILTER_LIST', message)
  return { type: FAILED_FETCH_CONTACT_PERSONS_FILTER_LIST }
}

export const contactPersonsFilterListActions = {
  fetchContactPersonsFilterList,
  successFetchContactPersonsFilterList,
  failedFetchContactPersonsFilterList,
}
